//Compliance

export const GetAllControlPlans = () => {
  return $.get('RiskManagement/GetAllControlPlans')
}

export const GetChildsByMahcId = (machid) => {
  return $.get('Compliance/GetChildsByMahcId?mahcId=' + machid)
}


export const GetAllParentMahcCodes = () => {
  return $.get('Compliance/GetAllParentMahcCodes')
}

export const GetAllUsers = () => {
  return $.get('Compliance/GetAllUsers')
}

export const AddCompliance = (model) => {
  return $.post('RiskManagement/AddControlPlan', model)
}

export const UpdateCompliance = (model) => {

  return $.post('RiskManagement/UpdateControlPlanById', model)
}


/*export const GetAllComplianceDocuments = () => {
  return $.get('RiskManagement/GetAllComplianceDocuments')
}*/

export const GetAllComplianceDocuments = (id) => {
  id = 0
  return $.get('Compliance/GetAllComplianceDocumentsTitle?LocationId='+id)
}
export const DeleteCompliance = (id) => {
  return $.post('RiskManagement/DeleteControlPlanById?Id=' + id)
}

// Risk Management

export const GetAllHazards = (id) => {
  return $.get('RiskManagement/GetAllHazardsByPoolId?PoolId='+id)
}

export const AddHazard = (model) => {
  return $.post('RiskManagement/AddHazard', model)
}

export const UpdateHazard = (model) => {

  return $.post('RiskManagement/UpdateHazardById', model)
}

export const DeleteHazard= (id) => {
  return $.post('RiskManagement/DeleteHazardById?Id=' + id)
}

// Mahc menu item

/*

export const GetAllMahc = (id) => {
  id = id ? id : ''
  return $.get('api/MahcCode/GetMAHCGrid?number=' + id)
}


export const GetAllMahcCodeAsTree = () => {
  return $.get('api/MahcCode/GetAllMahcCodeAsTree')
}
*/






// WEBPACK FOOTER //
// ./src/pages/RiskManagement/risk_management.service.js